import axios from 'axios';
import uuid from 'uuid/v4';
import { message } from 'ant-design-vue';
import router from '@/router/index';


// 为自己生成身份标识
let longUuid = localStorage.getItem('longUuid');
if (!longUuid) {
  longUuid = uuid();
  localStorage.setItem('longUuid', longUuid);
}

const instance = axios.create({
  baseURL: `//api.${window.location.hostname === 'localhost' ? 'map.e12e.com' : window.location.hostname}`,
  timeout: 20000,
  headers: {
    longUuid,
    'content-type': 'application/json',
  },
  responseType: 'json',
});

// Add a response interceptor
instance.interceptors.response.use((response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  // blob 响应（如文件下载）直接放行，不做 code 校验
  if (response.config.responseType === 'blob') {
    return response;
  }
  if (response.data.code !== 0 || (response.data.data && response.data.data.errcode)) {
    message.error(`出错了：${response.data.msg}`);
    if (response.data.msg === '身份验证失败') {
      router.push('/login');
    }
    throw Error(response.data.msg);
  }
  return response;
},
(error) => {
  message.error('操作失败');
  Promise.reject(error);
  throw new Error('操作失败');
});

export default instance;
